import { useMemo, useCallback, useState, useEffect } from "react";
import { RepairItem } from "types/restarter";

type Props = {
  loginEventCode: string;
};

type ReturnType = {
  loading: boolean;
  error: boolean;
  repairItems: RepairItem[];
};

export const useRepairItems = ({ loginEventCode }: Props): ReturnType => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [repairItems, setRepairItems] = useState<RepairItem[]>([]);

  const fetchRepairItems = useCallback(async () => {
    setLoading(true);
    setError(false);
    const url = `${import.meta.env.REACT_APP_REST_URL}/v1/restarter/repairItems`;
    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setRepairItems(data);
    } catch (error) {
      console.error("Failed to fetch repair items:", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchRepairItems();
  }, [fetchRepairItems]);

  const displayedItems = useMemo(
    () =>
      repairItems
        .filter(
          (repairItem: RepairItem) => repairItem?.eventCode === loginEventCode
        )
        .sort((a, b) => {
          if (!a.date) return 1;
          if (!b.date) return -1;
          return new Date(b.date).getTime() - new Date(a.date).getTime();
        }),
    [repairItems, loginEventCode]
  );

  return { loading, error, repairItems: displayedItems };
};
